import React from 'react';
import Nav from './components/nav/Nav';
import Header from './components/header/Header';
import About from './components/about/About';
import Contact from './components/contact/Contact';
import Experience from './components/experience/Experience';
import Portfolio from './components/portfolio/Portfolio';
import Footer from './components/footer/Footer';
import ScrollSpy from 'react-ui-scrollspy';


const App = () => {
  return (
    <>
    <Nav />
    <ScrollSpy offsetTop={100} useBoxMethod={false}>
      <Header />
      <About />
      <Experience />
      <Portfolio />
      <Contact />
      <Footer />
    </ScrollSpy>
    </>
  )
}

export default App;